import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerAppServiceWorker } from "./pwa/register-sw";

createRoot(document.getElementById("root")!).render(<App />);

// Guarded — no-ops (and cleans up) in dev, iframes, and Lovable preview hosts.
registerAppServiceWorker();
